import { isDefined } from "@clipboard-health/util-ts";
import { deprecatedDoNotUseLogError, logError } from "@src/appV2/lib/analytics";
import { SpecialQualifications } from "@src/appV2/Qualifications/types";
import { Worker } from "@src/appV2/Worker/api/types";

import { getQualifications } from "../licenseManager/api";
import { updateLicenseAndQualificationPreference } from "../licenseManager/utils";

export const processSuccessNonClinicalDeepLink = async (
  userId: string,
  searchParams: URLSearchParams
): Promise<Worker | undefined> => {
  const LOG_CONTEXT = "processSuccessNonClinicalDeepLink";
  const qualificationFromSearchParams = searchParams.get("qualification");

  if (!isDefined(qualificationFromSearchParams) || qualificationFromSearchParams.trim() === "") {
    deprecatedDoNotUseLogError({
      message: `${LOG_CONTEXT} qualification is missing in NON_CLINICAL dynamic link.`,
    });
    return;
  }
  try {
    const { data } = await getQualifications(true);
    const qualification = data
      .filter((item) => item.attributes.name !== SpecialQualifications.NURSE)
      .find(
        (item) => item.attributes.name.toLowerCase() === qualificationFromSearchParams.toLowerCase()
      );

    if (!isDefined(qualification)) {
      deprecatedDoNotUseLogError({
        message: `${LOG_CONTEXT} Invalid qualification ${qualificationFromSearchParams} in non clinical deep link`,
      });
      return;
    }
    const updatedAgent = await updateLicenseAndQualificationPreference(
      qualification.attributes.name,
      userId
    );
    return updatedAgent;
  } catch (error) {
    logError(
      `${LOG_CONTEXT} Error while updating license details for non clinical type userId: ${userId}`,
      {
        error: error,
      }
    );
    throw error;
  }
};

export function isValidUrl(uri: string): boolean {
  try {
    new URL(uri);
    return true;
  } catch {
    return false;
  }
}
